/**
 * Brazil pilot payment methods (D357, ADR-0046) — pack data for the neutral allowed-payment-methods policy.
 *
 * Owner decision D353 #5: the first pilot cycle is **cash only** in the two pilot markets, Paracatu-MG and Patos de
 * Minas-MG. The policy is an ordinary versioned, effective-dated `PolicySetting` (`payment.allowedMethods`,
 * `SELECT_PROVIDER`, protected `payment` class) at **market** scope. It only narrows Brazil's country payment frame
 * (`payment.capabilities` = instant payment, card, cash); it never adds a method (see `@vello/config`
 * `resolveAllowedPaymentMethods`). No country-level allowed set is published, so every other Brazil market keeps its
 * pre-policy behavior.
 *
 * Published by the existing pack publisher `publishBrazilPolicies` (and so by `@vello/pack-seed` and the W1-ENV pilot
 * seed). A re-run is a no-op: a published `(key, scope, scopeRef, version)` is immutable. Ending the cash-only cycle is a
 * new, higher version (or an `effectiveTo`), never an edit.
 *
 * This module imports nothing from `./brazil.js` (which imports it), so the market ids are spelled here as data.
 */
import { allowedPaymentMethodsSetting, marketId } from '@vello/config';
/** The pilot markets of wave 1 (D353 #4). Registered in the Layer 2 market registry by the pilot seed. */
export const BRAZIL_CASH_ONLY_PILOT_MARKETS = [marketId('br:paracatu'), marketId('br:patos-de-minas')];
/** The instant the cash-only pilot policy takes effect (the D353 owner decision date, UTC). */
export const BRAZIL_PILOT_PAYMENT_POLICY_EFFECTIVE_FROM = '2026-09-17T00:00:00Z';
/** The pilot value: cash only (neutral method token). */
export const BRAZIL_PILOT_ALLOWED_PAYMENT_METHODS = ['cash'];
/** The market-scoped allowed-payment-methods rows for the pilot markets (version 1 each). */
export function brazilPilotPaymentMethodSettings() {
    return BRAZIL_CASH_ONLY_PILOT_MARKETS.map((market) => allowedPaymentMethodsSetting({
        scope: 'market',
        scopeRef: market,
        methods: BRAZIL_PILOT_ALLOWED_PAYMENT_METHODS,
        version: 1,
        effectiveFrom: BRAZIL_PILOT_PAYMENT_POLICY_EFFECTIVE_FROM,
    }));
}
//# sourceMappingURL=payment-methods.js.map